/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpResponse, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ActivateMeritEmployee } from '@coin/shared/core/util-models-v2';
import { ApproveNewHire } from '@coin/shared/core/util-models-v2';
import { ChangeMeritScheme } from '@coin/shared/core/util-models-v2';
import { CreateMeritExport } from '@coin/shared/core/util-models-v2';
import { CreateMeritSimplifiedExport } from '@coin/shared/core/util-models-v2';
import { CreateOrReplaceIndividualAllocationValuePartner } from '@coin/shared/core/util-models-v2';
import { DeactivateEmployee } from '@coin/shared/core/util-models-v2';
import { ExtendedAllocationMember } from '@coin/shared/core/util-models-v2';
import { IncentiveAllocationPartnerEmployee } from '@coin/shared/core/util-models-v2';
import { IndividualAllocationValueModel } from '@coin/shared/core/util-models-v2';
import { IndividualMultiplierValueModel } from '@coin/shared/core/util-models-v2';
import { MercerData } from '@coin/shared/core/util-models-v2';
import { MeritAllocationMember } from '@coin/shared/core/util-models-v2';
import { MeritRowLevelSecurityAllocationMember } from '@coin/shared/core/util-models-v2';
import { PageOfAllocationSeason } from '@coin/shared/core/util-models-v2';
import { PageOfEmployeeSnapshotLight } from '@coin/shared/core/util-models-v2';
import { PageOfEquitySettings } from '@coin/shared/core/util-models-v2';
import { PageOfMeritIncentiveSettings } from '@coin/shared/core/util-models-v2';
import { PageOfMeritSimulationSettings } from '@coin/shared/core/util-models-v2';
import { PageOfString } from '@coin/shared/core/util-models-v2';
import { PartnerDashboardValues } from '@coin/shared/core/util-models-v2';
import { PromoteEmployee } from '@coin/shared/core/util-models-v2';
import { RejectMeritNewHire } from '@coin/shared/core/util-models-v2';
import { RejectMeritTermination } from '@coin/shared/core/util-models-v2';
import { ReviewEmployeePromotion } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfExportStatusMetadata } from '@coin/shared/core/util-models-v2';
import { UpdateAllocationMember } from '@coin/shared/core/util-models-v2';
import { UpdateEmployeeDataPositionClass } from '@coin/shared/core/util-models-v2';
import { UpdateEmployeeRelevantAllocationData } from '@coin/shared/core/util-models-v2';
import { UpdateIndividualMultiplierValue } from '@coin/shared/core/util-models-v2';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService, RequestArgs, RequestOptions } from '../api.base.service';

export interface ActivateEmployeeAllocationsParams {
  seasonId: string;
  employeeId: string;
  activateMeritEmployee?: ActivateMeritEmployee;
}

export interface ApproveNewHireAllocationsParams {
  seasonId: string;
  employeeId: string;
  approveNewHire?: ApproveNewHire;
}

export interface ChangeMeritSchemeAllocationsParams {
  seasonId: string;
  allocationMemberId: string;
  changeMeritScheme?: ChangeMeritScheme;
}

export interface DeactivateEmployeeAllocationsParams {
  seasonId: string;
  employeeId: string;
  deactivateEmployee?: DeactivateEmployee;
}

export interface EditEmployeeAllocationsParams {
  seasonId: string;
  employeeId: string;
  updateAllocationMember?: UpdateAllocationMember;
}

export interface ExportExportsParams {
  seasonId: string;
  targetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14;
  isMeritExcluded?: boolean;
  isEquityExcluded?: boolean;
  promotion?: Array<string>;
  newHire?: Array<string>;
  manuallyChanged?: Array<string>;
  termination?: Array<string>;
  populationChange?: Array<string>;
  equityPopulation?: Array<string>;
  meritPopulation?: Array<string>;
  workflow?: Array<string>;
  are?: Array<string>;
  contractStatus?: Array<number>;
  country?: Array<string>;
  countryInverted?: Array<string>;
  geoCluster?: Array<string>;
  geoClusterNode?: Array<string>;
  managementGroup?: Array<string>;
  gid?: Array<string>;
  firstname?: string;
  lastname?: string;
  pAOrgCode?: string;
  mercerJobCode?: Array<string>;
  orgCluster?: Array<string>;
  orgClusterNode?: Array<string>;
  positionClass?: Array<number>;
  orgCode?: Array<string>;
  orgCodeStartsWith?: Array<string>;
  individualMultiplier?: Array<'Open' | 'Edited' | 'Finalized' | 'AutoFinalized' | 'AutoFinalizedOpen'>;
  individualAllocationValueIsDone?: boolean;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  createMeritExport?: CreateMeritExport;
}

export interface ExportIndividualMultiplierExportsParams {
  seasonId: string;
  targetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14;
  isMeritExcluded?: boolean;
  isEquityExcluded?: boolean;
  promotion?: Array<string>;
  newHire?: Array<string>;
  manuallyChanged?: Array<string>;
  termination?: Array<string>;
  populationChange?: Array<string>;
  equityPopulation?: Array<string>;
  meritPopulation?: Array<string>;
  workflow?: Array<string>;
  are?: Array<string>;
  contractStatus?: Array<number>;
  country?: Array<string>;
  countryInverted?: Array<string>;
  geoCluster?: Array<string>;
  geoClusterNode?: Array<string>;
  managementGroup?: Array<string>;
  gid?: Array<string>;
  firstname?: string;
  lastname?: string;
  pAOrgCode?: string;
  mercerJobCode?: Array<string>;
  orgCluster?: Array<string>;
  orgClusterNode?: Array<string>;
  positionClass?: Array<number>;
  orgCode?: Array<string>;
  orgCodeStartsWith?: Array<string>;
  individualMultiplier?: Array<'Open' | 'Edited' | 'Finalized' | 'AutoFinalized' | 'AutoFinalizedOpen'>;
  individualAllocationValueIsDone?: boolean;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  createMeritExport?: CreateMeritExport;
}

export interface ExportSimplifiedValuesExportsParams {
  seasonId: string;
  targetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14;
  isMeritExcluded?: boolean;
  isEquityExcluded?: boolean;
  promotion?: Array<string>;
  newHire?: Array<string>;
  manuallyChanged?: Array<string>;
  termination?: Array<string>;
  populationChange?: Array<string>;
  equityPopulation?: Array<string>;
  meritPopulation?: Array<string>;
  workflow?: Array<string>;
  are?: Array<string>;
  contractStatus?: Array<number>;
  country?: Array<string>;
  countryInverted?: Array<string>;
  geoCluster?: Array<string>;
  geoClusterNode?: Array<string>;
  managementGroup?: Array<string>;
  gid?: Array<string>;
  firstname?: string;
  lastname?: string;
  pAOrgCode?: string;
  mercerJobCode?: Array<string>;
  orgCluster?: Array<string>;
  orgClusterNode?: Array<string>;
  positionClass?: Array<number>;
  orgCode?: Array<string>;
  orgCodeStartsWith?: Array<string>;
  individualMultiplier?: Array<'Open' | 'Edited' | 'Finalized' | 'AutoFinalized' | 'AutoFinalizedOpen'>;
  individualAllocationValueIsDone?: boolean;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  createMeritSimplifiedExport?: CreateMeritSimplifiedExport;
}

export interface GetAllocationMemberForEmployeeAllocationsParams {
  seasonId: string;
  employeeId: string;
}

export interface GetEmployeeAllocationsParams {
  seasonId: string;
  employeeId: string;
}

export interface GetEmployeesForSeasonAllocationsParams {
  seasonId: string;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  queryTargetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14;
  queryIsMeritExcluded?: boolean;
  queryIsEquityExcluded?: boolean;
  queryPromotion?: Array<string>;
  queryNewHire?: Array<string>;
  queryManuallyChanged?: Array<string>;
  queryTermination?: Array<string>;
  queryPopulationChange?: Array<string>;
  queryEquityPopulation?: Array<string>;
  queryMeritPopulation?: Array<string>;
  queryWorkflow?: Array<string>;
  queryAre?: Array<string>;
  queryContractStatus?: Array<number>;
  queryCountry?: Array<string>;
  queryCountryInverted?: Array<string>;
  queryGeoCluster?: Array<string>;
  queryGeoClusterNode?: Array<string>;
  queryManagementGroup?: Array<string>;
  queryGid?: Array<string>;
  queryFirstname?: string;
  queryLastname?: string;
  queryPAOrgCode?: string;
  queryMercerJobCode?: Array<string>;
  queryOrgCluster?: Array<string>;
  queryOrgClusterNode?: Array<string>;
  queryPositionClass?: Array<number>;
  queryOrgCode?: Array<string>;
  queryOrgCodeStartsWith?: Array<string>;
  queryIndividualMultiplier?: Array<'Open' | 'Edited' | 'Finalized' | 'AutoFinalized' | 'AutoFinalizedOpen'>;
  queryIndividualAllocationValueIsDone?: boolean;
}

export interface GetEquitySettingsAllocationsParams {
  seasonId: string;
  employeeId: string;
  page?: number;
  size?: number;
  positionClass?: number;
}

export interface GetIncentiveSettingsAllocationsParams {
  seasonId: string;
  employeeId: string;
  page?: number;
  size?: number;
}

export interface GetMeritSettingsAllocationsParams {
  seasonId: string;
  employeeId: string;
  page?: number;
  size?: number;
}

export interface MeritPartnerGetDashboardParams {
  seasonId?: string;
}

export interface MeritPartnerGetTotalsIncentiveAllocationsParams {
  employeeId: string;
  meritSeasonId?: string;
}

export interface MeritPartnerQueryEmployeesParams {
  search?: string;
  firstname?: string;
  lastname?: string;
  gid?: string;
  orgCode?: string;
  placeOfAction?: Array<string>;
  fullName?: string;
  fullNameReversed?: string;
  seasonId?: string;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
}

export interface MeritPartnerQuerySeasonsParams {
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
}

export interface MeritPartnerUpdateAllocationValuesAllocationsParams {
  seasonId: string;
  employeeId: string;
  createOrReplaceIndividualAllocationValuePartner?: CreateOrReplaceIndividualAllocationValuePartner;
}

export interface MeritPartnerUpdateAllocationValuesIncentiveAllocationsParams {
  allocationMemberId: string;
  updateIndividualMultiplierValue?: UpdateIndividualMultiplierValue;
}

export interface PromoteEmployeeAllocationsParams {
  seasonId: string;
  employeeId: string;
  promoteEmployee?: PromoteEmployee;
}

export interface QueryFieldValuesAllocationsParams {
  seasonId: string;
  targetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14;
  isMeritExcluded?: boolean;
  isEquityExcluded?: boolean;
  promotion?: Array<string>;
  newHire?: Array<string>;
  manuallyChanged?: Array<string>;
  termination?: Array<string>;
  populationChange?: Array<string>;
  equityPopulation?: Array<string>;
  meritPopulation?: Array<string>;
  workflow?: Array<string>;
  are?: Array<string>;
  contractStatus?: Array<number>;
  country?: Array<string>;
  countryInverted?: Array<string>;
  geoCluster?: Array<string>;
  geoClusterNode?: Array<string>;
  managementGroup?: Array<string>;
  gid?: Array<string>;
  firstname?: string;
  lastname?: string;
  pAOrgCode?: string;
  mercerJobCode?: Array<string>;
  orgCluster?: Array<string>;
  orgClusterNode?: Array<string>;
  positionClass?: Array<number>;
  orgCode?: Array<string>;
  orgCodeStartsWith?: Array<string>;
  individualMultiplier?: Array<'Open' | 'Edited' | 'Finalized' | 'AutoFinalized' | 'AutoFinalizedOpen'>;
  individualAllocationValueIsDone?: boolean;
  page?: number;
  size?: number;
}

export interface RejectNewHireAllocationsParams {
  seasonId: string;
  employeeId: string;
  rejectMeritNewHire?: RejectMeritNewHire;
}

export interface RejectTerminationAllocationsParams {
  seasonId: string;
  employeeId: string;
  rejectMeritTermination?: RejectMeritTermination;
}

export interface ReviewEmployeePromotionAllocationsParams {
  seasonId: string;
  employeeId: string;
  reviewEmployeePromotion?: ReviewEmployeePromotion;
}

export interface UpdateEmployeeDataPositionClassAllocationsParams {
  seasonId: string;
  employeeId: string;
  updateEmployeeDataPositionClass?: UpdateEmployeeDataPositionClass;
}

export interface UpdateEmployeeRelevantDataAllocationsParams {
  seasonId: string;
  employeeId: string;
  updateEmployeeRelevantAllocationData?: UpdateEmployeeRelevantAllocationData;
}

export interface UpdateMercerDataAllocationsParams {
  seasonId: string;
  employeeId: string;
  mercerData?: MercerData;
}

@Injectable({
  providedIn: 'root'
})
export class MeritPartnerService extends BaseService {
  constructor(
    httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    super(httpClient, basePath, configuration);
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public activateEmployeeAllocations(
    requestParameters?: ActivateEmployeeAllocationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<ExtendedAllocationMember>;
  public activateEmployeeAllocations(
    requestParameters?: ActivateEmployeeAllocationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<ExtendedAllocationMember>>;
  public activateEmployeeAllocations(
    requestParameters?: ActivateEmployeeAllocationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<ExtendedAllocationMember>>;
  public activateEmployeeAllocations(
    requestParameters?: ActivateEmployeeAllocationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('activateEmployeeAllocations', { seasonId, employeeId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v2/master/seasons/merit/partner/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/allocations/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/activate`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.activateMeritEmployee,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public approveNewHireAllocations(
    requestParameters?: ApproveNewHireAllocationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<ExtendedAllocationMember>;
  public approveNewHireAllocations(
    requestParameters?: ApproveNewHireAllocationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<ExtendedAllocationMember>>;
  public approveNewHireAllocations(
    requestParameters?: ApproveNewHireAllocationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<ExtendedAllocationMember>>;
  public approveNewHireAllocations(
    requestParameters?: ApproveNewHireAllocationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('approveNewHireAllocations', { seasonId, employeeId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v2/master/seasons/merit/partner/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/allocations/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/approve-new-hire`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.approveNewHire,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public changeMeritSchemeAllocations(
    requestParameters?: ChangeMeritSchemeAllocationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<ExtendedAllocationMember>;
  public changeMeritSchemeAllocations(
    requestParameters?: ChangeMeritSchemeAllocationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<ExtendedAllocationMember>>;
  public changeMeritSchemeAllocations(
    requestParameters?: ChangeMeritSchemeAllocationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<ExtendedAllocationMember>>;
  public changeMeritSchemeAllocations(
    requestParameters?: ChangeMeritSchemeAllocationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const allocationMemberId = requestParameters?.allocationMemberId;
    this.checkRequired('changeMeritSchemeAllocations', { seasonId, allocationMemberId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v2/master/seasons/merit/partner/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/allocations/${this.configuration.encodeParam({ name: 'allocationMemberId', value: allocationMemberId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/change-scheme`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.changeMeritScheme,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deactivateEmployeeAllocations(
    requestParameters?: DeactivateEmployeeAllocationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<ExtendedAllocationMember>;
  public deactivateEmployeeAllocations(
    requestParameters?: DeactivateEmployeeAllocationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<ExtendedAllocationMember>>;
  public deactivateEmployeeAllocations(
    requestParameters?: DeactivateEmployeeAllocationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<ExtendedAllocationMember>>;
  public deactivateEmployeeAllocations(
    requestParameters?: DeactivateEmployeeAllocationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('deactivateEmployeeAllocations', { seasonId, employeeId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v2/master/seasons/merit/partner/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/allocations/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/deactivate`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.deactivateEmployee,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public editEmployeeAllocations(
    requestParameters?: EditEmployeeAllocationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<ExtendedAllocationMember>;
  public editEmployeeAllocations(
    requestParameters?: EditEmployeeAllocationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<ExtendedAllocationMember>>;
  public editEmployeeAllocations(
    requestParameters?: EditEmployeeAllocationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<ExtendedAllocationMember>>;
  public editEmployeeAllocations(
    requestParameters?: EditEmployeeAllocationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('editEmployeeAllocations', { seasonId, employeeId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v2/master/seasons/merit/partner/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/allocations/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateAllocationMember,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportExports(
    requestParameters?: ExportExportsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportExports(
    requestParameters?: ExportExportsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportExports(
    requestParameters?: ExportExportsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportExports(requestParameters?: ExportExportsParams, ...args: RequestArgs): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('exportExports', { seasonId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v2/master/seasons/merit/partner/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/allocation/export`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        TargetProperty: requestParameters?.targetProperty,
        IsMeritExcluded: requestParameters?.isMeritExcluded,
        IsEquityExcluded: requestParameters?.isEquityExcluded,
        Promotion: requestParameters?.promotion,
        NewHire: requestParameters?.newHire,
        ManuallyChanged: requestParameters?.manuallyChanged,
        Termination: requestParameters?.termination,
        PopulationChange: requestParameters?.populationChange,
        EquityPopulation: requestParameters?.equityPopulation,
        MeritPopulation: requestParameters?.meritPopulation,
        Workflow: requestParameters?.workflow,
        Are: requestParameters?.are,
        ContractStatus: requestParameters?.contractStatus,
        Country: requestParameters?.country,
        CountryInverted: requestParameters?.countryInverted,
        GeoCluster: requestParameters?.geoCluster,
        GeoClusterNode: requestParameters?.geoClusterNode,
        ManagementGroup: requestParameters?.managementGroup,
        Gid: requestParameters?.gid,
        Firstname: requestParameters?.firstname,
        Lastname: requestParameters?.lastname,
        PAOrgCode: requestParameters?.pAOrgCode,
        MercerJobCode: requestParameters?.mercerJobCode,
        OrgCluster: requestParameters?.orgCluster,
        OrgClusterNode: requestParameters?.orgClusterNode,
        PositionClass: requestParameters?.positionClass,
        OrgCode: requestParameters?.orgCode,
        OrgCodeStartsWith: requestParameters?.orgCodeStartsWith,
        IndividualMultiplier: requestParameters?.individualMultiplier,
        IndividualAllocationValueIsDone: requestParameters?.individualAllocationValueIsDone,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property
      },
      body: requestParameters?.createMeritExport,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportIndividualMultiplierExports(
    requestParameters?: ExportIndividualMultiplierExportsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportIndividualMultiplierExports(
    requestParameters?: ExportIndividualMultiplierExportsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportIndividualMultiplierExports(
    requestParameters?: ExportIndividualMultiplierExportsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportIndividualMultiplierExports(
    requestParameters?: ExportIndividualMultiplierExportsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('exportIndividualMultiplierExports', { seasonId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v2/master/seasons/merit/partner/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/individual-multiplier/export`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        TargetProperty: requestParameters?.targetProperty,
        IsMeritExcluded: requestParameters?.isMeritExcluded,
        IsEquityExcluded: requestParameters?.isEquityExcluded,
        Promotion: requestParameters?.promotion,
        NewHire: requestParameters?.newHire,
        ManuallyChanged: requestParameters?.manuallyChanged,
        Termination: requestParameters?.termination,
        PopulationChange: requestParameters?.populationChange,
        EquityPopulation: requestParameters?.equityPopulation,
        MeritPopulation: requestParameters?.meritPopulation,
        Workflow: requestParameters?.workflow,
        Are: requestParameters?.are,
        ContractStatus: requestParameters?.contractStatus,
        Country: requestParameters?.country,
        CountryInverted: requestParameters?.countryInverted,
        GeoCluster: requestParameters?.geoCluster,
        GeoClusterNode: requestParameters?.geoClusterNode,
        ManagementGroup: requestParameters?.managementGroup,
        Gid: requestParameters?.gid,
        Firstname: requestParameters?.firstname,
        Lastname: requestParameters?.lastname,
        PAOrgCode: requestParameters?.pAOrgCode,
        MercerJobCode: requestParameters?.mercerJobCode,
        OrgCluster: requestParameters?.orgCluster,
        OrgClusterNode: requestParameters?.orgClusterNode,
        PositionClass: requestParameters?.positionClass,
        OrgCode: requestParameters?.orgCode,
        OrgCodeStartsWith: requestParameters?.orgCodeStartsWith,
        IndividualMultiplier: requestParameters?.individualMultiplier,
        IndividualAllocationValueIsDone: requestParameters?.individualAllocationValueIsDone,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property
      },
      body: requestParameters?.createMeritExport,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportSimplifiedValuesExports(
    requestParameters?: ExportSimplifiedValuesExportsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportSimplifiedValuesExports(
    requestParameters?: ExportSimplifiedValuesExportsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportSimplifiedValuesExports(
    requestParameters?: ExportSimplifiedValuesExportsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportSimplifiedValuesExports(
    requestParameters?: ExportSimplifiedValuesExportsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('exportSimplifiedValuesExports', { seasonId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v2/master/seasons/merit/partner/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/allocation/simplified/export`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        TargetProperty: requestParameters?.targetProperty,
        IsMeritExcluded: requestParameters?.isMeritExcluded,
        IsEquityExcluded: requestParameters?.isEquityExcluded,
        Promotion: requestParameters?.promotion,
        NewHire: requestParameters?.newHire,
        ManuallyChanged: requestParameters?.manuallyChanged,
        Termination: requestParameters?.termination,
        PopulationChange: requestParameters?.populationChange,
        EquityPopulation: requestParameters?.equityPopulation,
        MeritPopulation: requestParameters?.meritPopulation,
        Workflow: requestParameters?.workflow,
        Are: requestParameters?.are,
        ContractStatus: requestParameters?.contractStatus,
        Country: requestParameters?.country,
        CountryInverted: requestParameters?.countryInverted,
        GeoCluster: requestParameters?.geoCluster,
        GeoClusterNode: requestParameters?.geoClusterNode,
        ManagementGroup: requestParameters?.managementGroup,
        Gid: requestParameters?.gid,
        Firstname: requestParameters?.firstname,
        Lastname: requestParameters?.lastname,
        PAOrgCode: requestParameters?.pAOrgCode,
        MercerJobCode: requestParameters?.mercerJobCode,
        OrgCluster: requestParameters?.orgCluster,
        OrgClusterNode: requestParameters?.orgClusterNode,
        PositionClass: requestParameters?.positionClass,
        OrgCode: requestParameters?.orgCode,
        OrgCodeStartsWith: requestParameters?.orgCodeStartsWith,
        IndividualMultiplier: requestParameters?.individualMultiplier,
        IndividualAllocationValueIsDone: requestParameters?.individualAllocationValueIsDone,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property
      },
      body: requestParameters?.createMeritSimplifiedExport,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAllocationMemberForEmployeeAllocations(
    requestParameters?: GetAllocationMemberForEmployeeAllocationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<ExtendedAllocationMember>;
  public getAllocationMemberForEmployeeAllocations(
    requestParameters?: GetAllocationMemberForEmployeeAllocationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<ExtendedAllocationMember>>;
  public getAllocationMemberForEmployeeAllocations(
    requestParameters?: GetAllocationMemberForEmployeeAllocationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<ExtendedAllocationMember>>;
  public getAllocationMemberForEmployeeAllocations(
    requestParameters?: GetAllocationMemberForEmployeeAllocationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('getAllocationMemberForEmployeeAllocations', { seasonId, employeeId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/seasons/merit/partner/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/allocations/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getEmployeeAllocations(
    requestParameters?: GetEmployeeAllocationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MeritRowLevelSecurityAllocationMember>;
  public getEmployeeAllocations(
    requestParameters?: GetEmployeeAllocationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MeritRowLevelSecurityAllocationMember>>;
  public getEmployeeAllocations(
    requestParameters?: GetEmployeeAllocationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MeritRowLevelSecurityAllocationMember>>;
  public getEmployeeAllocations(
    requestParameters?: GetEmployeeAllocationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('getEmployeeAllocations', { seasonId, employeeId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/seasons/merit/partner/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/allocations/total/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getEmployeesForSeasonAllocations(
    requestParameters?: GetEmployeesForSeasonAllocationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfEmployeeSnapshotLight>;
  public getEmployeesForSeasonAllocations(
    requestParameters?: GetEmployeesForSeasonAllocationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfEmployeeSnapshotLight>>;
  public getEmployeesForSeasonAllocations(
    requestParameters?: GetEmployeesForSeasonAllocationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfEmployeeSnapshotLight>>;
  public getEmployeesForSeasonAllocations(
    requestParameters?: GetEmployeesForSeasonAllocationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('getEmployeesForSeasonAllocations', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/seasons/merit/partner/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/allocations/employees`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty,
        'Query.TargetProperty': requestParameters?.queryTargetProperty,
        'Query.IsMeritExcluded': requestParameters?.queryIsMeritExcluded,
        'Query.IsEquityExcluded': requestParameters?.queryIsEquityExcluded,
        'Query.Promotion': requestParameters?.queryPromotion,
        'Query.NewHire': requestParameters?.queryNewHire,
        'Query.ManuallyChanged': requestParameters?.queryManuallyChanged,
        'Query.Termination': requestParameters?.queryTermination,
        'Query.PopulationChange': requestParameters?.queryPopulationChange,
        'Query.EquityPopulation': requestParameters?.queryEquityPopulation,
        'Query.MeritPopulation': requestParameters?.queryMeritPopulation,
        'Query.Workflow': requestParameters?.queryWorkflow,
        'Query.Are': requestParameters?.queryAre,
        'Query.ContractStatus': requestParameters?.queryContractStatus,
        'Query.Country': requestParameters?.queryCountry,
        'Query.CountryInverted': requestParameters?.queryCountryInverted,
        'Query.GeoCluster': requestParameters?.queryGeoCluster,
        'Query.GeoClusterNode': requestParameters?.queryGeoClusterNode,
        'Query.ManagementGroup': requestParameters?.queryManagementGroup,
        'Query.Gid': requestParameters?.queryGid,
        'Query.Firstname': requestParameters?.queryFirstname,
        'Query.Lastname': requestParameters?.queryLastname,
        'Query.PAOrgCode': requestParameters?.queryPAOrgCode,
        'Query.MercerJobCode': requestParameters?.queryMercerJobCode,
        'Query.OrgCluster': requestParameters?.queryOrgCluster,
        'Query.OrgClusterNode': requestParameters?.queryOrgClusterNode,
        'Query.PositionClass': requestParameters?.queryPositionClass,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.OrgCodeStartsWith': requestParameters?.queryOrgCodeStartsWith,
        'Query.IndividualMultiplier': requestParameters?.queryIndividualMultiplier,
        'Query.IndividualAllocationValueIsDone': requestParameters?.queryIndividualAllocationValueIsDone
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getEquitySettingsAllocations(
    requestParameters?: GetEquitySettingsAllocationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfEquitySettings>;
  public getEquitySettingsAllocations(
    requestParameters?: GetEquitySettingsAllocationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfEquitySettings>>;
  public getEquitySettingsAllocations(
    requestParameters?: GetEquitySettingsAllocationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfEquitySettings>>;
  public getEquitySettingsAllocations(
    requestParameters?: GetEquitySettingsAllocationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('getEquitySettingsAllocations', { seasonId, employeeId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/seasons/merit/partner/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/allocations/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/equity-settings`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        positionClass: requestParameters?.positionClass
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getIncentiveSettingsAllocations(
    requestParameters?: GetIncentiveSettingsAllocationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfMeritIncentiveSettings>;
  public getIncentiveSettingsAllocations(
    requestParameters?: GetIncentiveSettingsAllocationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfMeritIncentiveSettings>>;
  public getIncentiveSettingsAllocations(
    requestParameters?: GetIncentiveSettingsAllocationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfMeritIncentiveSettings>>;
  public getIncentiveSettingsAllocations(
    requestParameters?: GetIncentiveSettingsAllocationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('getIncentiveSettingsAllocations', { seasonId, employeeId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/seasons/merit/partner/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/allocations/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/incentive-settings`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getMeritSettingsAllocations(
    requestParameters?: GetMeritSettingsAllocationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfMeritSimulationSettings>;
  public getMeritSettingsAllocations(
    requestParameters?: GetMeritSettingsAllocationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfMeritSimulationSettings>>;
  public getMeritSettingsAllocations(
    requestParameters?: GetMeritSettingsAllocationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfMeritSimulationSettings>>;
  public getMeritSettingsAllocations(
    requestParameters?: GetMeritSettingsAllocationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('getMeritSettingsAllocations', { seasonId, employeeId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/seasons/merit/partner/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/allocations/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/merit-settings`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public meritPartnerGetDashboard(
    requestParameters?: MeritPartnerGetDashboardParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PartnerDashboardValues>;
  public meritPartnerGetDashboard(
    requestParameters?: MeritPartnerGetDashboardParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PartnerDashboardValues>>;
  public meritPartnerGetDashboard(
    requestParameters?: MeritPartnerGetDashboardParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PartnerDashboardValues>>;
  public meritPartnerGetDashboard(
    requestParameters?: MeritPartnerGetDashboardParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/seasons/merit/partner/dashboard`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { seasonId: requestParameters?.seasonId }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public meritPartnerGetTotalsIncentiveAllocations(
    requestParameters?: MeritPartnerGetTotalsIncentiveAllocationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<IncentiveAllocationPartnerEmployee>;
  public meritPartnerGetTotalsIncentiveAllocations(
    requestParameters?: MeritPartnerGetTotalsIncentiveAllocationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<IncentiveAllocationPartnerEmployee>>;
  public meritPartnerGetTotalsIncentiveAllocations(
    requestParameters?: MeritPartnerGetTotalsIncentiveAllocationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<IncentiveAllocationPartnerEmployee>>;
  public meritPartnerGetTotalsIncentiveAllocations(
    requestParameters?: MeritPartnerGetTotalsIncentiveAllocationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('meritPartnerGetTotalsIncentiveAllocations', { employeeId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/seasons/incentive/partner/allocations/total/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { meritSeasonId: requestParameters?.meritSeasonId }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public meritPartnerQueryEmployees(
    requestParameters?: MeritPartnerQueryEmployeesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfEmployeeSnapshotLight>;
  public meritPartnerQueryEmployees(
    requestParameters?: MeritPartnerQueryEmployeesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfEmployeeSnapshotLight>>;
  public meritPartnerQueryEmployees(
    requestParameters?: MeritPartnerQueryEmployeesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfEmployeeSnapshotLight>>;
  public meritPartnerQueryEmployees(
    requestParameters?: MeritPartnerQueryEmployeesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/seasons/merit/partner/employees`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Search: requestParameters?.search,
        Firstname: requestParameters?.firstname,
        Lastname: requestParameters?.lastname,
        Gid: requestParameters?.gid,
        OrgCode: requestParameters?.orgCode,
        PlaceOfAction: requestParameters?.placeOfAction,
        FullName: requestParameters?.fullName,
        FullNameReversed: requestParameters?.fullNameReversed,
        SeasonId: requestParameters?.seasonId,
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public meritPartnerQuerySeasons(
    requestParameters?: MeritPartnerQuerySeasonsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfAllocationSeason>;
  public meritPartnerQuerySeasons(
    requestParameters?: MeritPartnerQuerySeasonsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfAllocationSeason>>;
  public meritPartnerQuerySeasons(
    requestParameters?: MeritPartnerQuerySeasonsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfAllocationSeason>>;
  public meritPartnerQuerySeasons(
    requestParameters?: MeritPartnerQuerySeasonsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/seasons/merit/partner/seasons`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public meritPartnerUpdateAllocationValuesAllocations(
    requestParameters?: MeritPartnerUpdateAllocationValuesAllocationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<IndividualAllocationValueModel>;
  public meritPartnerUpdateAllocationValuesAllocations(
    requestParameters?: MeritPartnerUpdateAllocationValuesAllocationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<IndividualAllocationValueModel>>;
  public meritPartnerUpdateAllocationValuesAllocations(
    requestParameters?: MeritPartnerUpdateAllocationValuesAllocationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<IndividualAllocationValueModel>>;
  public meritPartnerUpdateAllocationValuesAllocations(
    requestParameters?: MeritPartnerUpdateAllocationValuesAllocationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('meritPartnerUpdateAllocationValuesAllocations', { seasonId, employeeId });
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v2/master/seasons/merit/partner/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/allocations/values/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createOrReplaceIndividualAllocationValuePartner,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public meritPartnerUpdateAllocationValuesIncentiveAllocations(
    requestParameters?: MeritPartnerUpdateAllocationValuesIncentiveAllocationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<IndividualMultiplierValueModel>;
  public meritPartnerUpdateAllocationValuesIncentiveAllocations(
    requestParameters?: MeritPartnerUpdateAllocationValuesIncentiveAllocationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<IndividualMultiplierValueModel>>;
  public meritPartnerUpdateAllocationValuesIncentiveAllocations(
    requestParameters?: MeritPartnerUpdateAllocationValuesIncentiveAllocationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<IndividualMultiplierValueModel>>;
  public meritPartnerUpdateAllocationValuesIncentiveAllocations(
    requestParameters?: MeritPartnerUpdateAllocationValuesIncentiveAllocationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const allocationMemberId = requestParameters?.allocationMemberId;
    this.checkRequired('meritPartnerUpdateAllocationValuesIncentiveAllocations', { allocationMemberId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v2/master/seasons/incentive/partner/allocations/${this.configuration.encodeParam({ name: 'allocationMemberId', value: allocationMemberId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/values`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateIndividualMultiplierValue,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public promoteEmployeeAllocations(
    requestParameters?: PromoteEmployeeAllocationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MeritAllocationMember>;
  public promoteEmployeeAllocations(
    requestParameters?: PromoteEmployeeAllocationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MeritAllocationMember>>;
  public promoteEmployeeAllocations(
    requestParameters?: PromoteEmployeeAllocationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MeritAllocationMember>>;
  public promoteEmployeeAllocations(
    requestParameters?: PromoteEmployeeAllocationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('promoteEmployeeAllocations', { seasonId, employeeId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v2/master/seasons/merit/partner/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/allocations/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/promote`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.promoteEmployee,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValuesAllocations(
    requestParameters?: QueryFieldValuesAllocationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public queryFieldValuesAllocations(
    requestParameters?: QueryFieldValuesAllocationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public queryFieldValuesAllocations(
    requestParameters?: QueryFieldValuesAllocationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public queryFieldValuesAllocations(
    requestParameters?: QueryFieldValuesAllocationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('queryFieldValuesAllocations', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/seasons/merit/partner/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/allocations/field-values`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        TargetProperty: requestParameters?.targetProperty,
        IsMeritExcluded: requestParameters?.isMeritExcluded,
        IsEquityExcluded: requestParameters?.isEquityExcluded,
        Promotion: requestParameters?.promotion,
        NewHire: requestParameters?.newHire,
        ManuallyChanged: requestParameters?.manuallyChanged,
        Termination: requestParameters?.termination,
        PopulationChange: requestParameters?.populationChange,
        EquityPopulation: requestParameters?.equityPopulation,
        MeritPopulation: requestParameters?.meritPopulation,
        Workflow: requestParameters?.workflow,
        Are: requestParameters?.are,
        ContractStatus: requestParameters?.contractStatus,
        Country: requestParameters?.country,
        CountryInverted: requestParameters?.countryInverted,
        GeoCluster: requestParameters?.geoCluster,
        GeoClusterNode: requestParameters?.geoClusterNode,
        ManagementGroup: requestParameters?.managementGroup,
        Gid: requestParameters?.gid,
        Firstname: requestParameters?.firstname,
        Lastname: requestParameters?.lastname,
        PAOrgCode: requestParameters?.pAOrgCode,
        MercerJobCode: requestParameters?.mercerJobCode,
        OrgCluster: requestParameters?.orgCluster,
        OrgClusterNode: requestParameters?.orgClusterNode,
        PositionClass: requestParameters?.positionClass,
        OrgCode: requestParameters?.orgCode,
        OrgCodeStartsWith: requestParameters?.orgCodeStartsWith,
        IndividualMultiplier: requestParameters?.individualMultiplier,
        IndividualAllocationValueIsDone: requestParameters?.individualAllocationValueIsDone,
        Page: requestParameters?.page,
        Size: requestParameters?.size
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public rejectNewHireAllocations(
    requestParameters?: RejectNewHireAllocationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<ExtendedAllocationMember>;
  public rejectNewHireAllocations(
    requestParameters?: RejectNewHireAllocationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<ExtendedAllocationMember>>;
  public rejectNewHireAllocations(
    requestParameters?: RejectNewHireAllocationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<ExtendedAllocationMember>>;
  public rejectNewHireAllocations(
    requestParameters?: RejectNewHireAllocationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('rejectNewHireAllocations', { seasonId, employeeId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v2/master/seasons/merit/partner/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/allocations/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/reject-new-hire`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.rejectMeritNewHire,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public rejectTerminationAllocations(
    requestParameters?: RejectTerminationAllocationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<ExtendedAllocationMember>;
  public rejectTerminationAllocations(
    requestParameters?: RejectTerminationAllocationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<ExtendedAllocationMember>>;
  public rejectTerminationAllocations(
    requestParameters?: RejectTerminationAllocationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<ExtendedAllocationMember>>;
  public rejectTerminationAllocations(
    requestParameters?: RejectTerminationAllocationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('rejectTerminationAllocations', { seasonId, employeeId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v2/master/seasons/merit/partner/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/allocations/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/reject-termination`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.rejectMeritTermination,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public reviewEmployeePromotionAllocations(
    requestParameters?: ReviewEmployeePromotionAllocationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<ExtendedAllocationMember>;
  public reviewEmployeePromotionAllocations(
    requestParameters?: ReviewEmployeePromotionAllocationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<ExtendedAllocationMember>>;
  public reviewEmployeePromotionAllocations(
    requestParameters?: ReviewEmployeePromotionAllocationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<ExtendedAllocationMember>>;
  public reviewEmployeePromotionAllocations(
    requestParameters?: ReviewEmployeePromotionAllocationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('reviewEmployeePromotionAllocations', { seasonId, employeeId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v2/master/seasons/merit/partner/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/allocations/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/review-promotion`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.reviewEmployeePromotion,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateEmployeeDataPositionClassAllocations(
    requestParameters?: UpdateEmployeeDataPositionClassAllocationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<ExtendedAllocationMember>;
  public updateEmployeeDataPositionClassAllocations(
    requestParameters?: UpdateEmployeeDataPositionClassAllocationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<ExtendedAllocationMember>>;
  public updateEmployeeDataPositionClassAllocations(
    requestParameters?: UpdateEmployeeDataPositionClassAllocationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<ExtendedAllocationMember>>;
  public updateEmployeeDataPositionClassAllocations(
    requestParameters?: UpdateEmployeeDataPositionClassAllocationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('updateEmployeeDataPositionClassAllocations', { seasonId, employeeId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v2/master/seasons/merit/partner/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/allocations/employee-data/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/change-pc`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateEmployeeDataPositionClass,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateEmployeeRelevantDataAllocations(
    requestParameters?: UpdateEmployeeRelevantDataAllocationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<ExtendedAllocationMember>;
  public updateEmployeeRelevantDataAllocations(
    requestParameters?: UpdateEmployeeRelevantDataAllocationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<ExtendedAllocationMember>>;
  public updateEmployeeRelevantDataAllocations(
    requestParameters?: UpdateEmployeeRelevantDataAllocationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<ExtendedAllocationMember>>;
  public updateEmployeeRelevantDataAllocations(
    requestParameters?: UpdateEmployeeRelevantDataAllocationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('updateEmployeeRelevantDataAllocations', { seasonId, employeeId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v2/master/seasons/merit/partner/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/allocations/employee-data/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateEmployeeRelevantAllocationData,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateMercerDataAllocations(
    requestParameters?: UpdateMercerDataAllocationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MeritAllocationMember>;
  public updateMercerDataAllocations(
    requestParameters?: UpdateMercerDataAllocationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MeritAllocationMember>>;
  public updateMercerDataAllocations(
    requestParameters?: UpdateMercerDataAllocationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MeritAllocationMember>>;
  public updateMercerDataAllocations(
    requestParameters?: UpdateMercerDataAllocationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('updateMercerDataAllocations', { seasonId, employeeId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v2/master/seasons/merit/partner/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/allocations/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/update`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.mercerData,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }
}
